import get from '@invitato/helpers/dist/getLocale';

export const description = get(
  `Ups, saat ini Anda menggunakan mode gelap (darkmode). Anda bisa menonaktifkan mode gelap terlebih dahulu untuk dapat mengakses seluruh fitur undangan secara maksimal.`,
  `Oops, you are currently using dark mode. You can disable dark mode first to be able to access all the features to the fullest.`,
);

export const title = get('Informasi', 'Darkmode Warning');
export const understand = get('Oke, saya mengerti', 'Understood');
